import React, { useContext, useState } from "react";
import firebase from "firebase/app";
import { firestore } from "../firebase";
import { UserContext } from "../providers/UserProvider";
import "./chat-input.css";

export default function ChatInput(props) {
    const { channelId, channelName } = props
    const [input, setInput] = useState("")
    const user = useContext(UserContext);
    console.log(user, "usre")
    const photoUrl = "https://res.cloudinary.com/dqcsk8rsc/image/upload/v1577268053/avatar-1-bitmoji_upgwhc.png";


    const sendMessage = (e) => {
        e.preventDefault();
        if (channelId) {
            firestore
                .collection("channels")
                .doc(channelId)
                .collection("messages")
                .add({
                    message: input,
                    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                    user: user?.displayName,
                    userImage: user?.photoURL || photoUrl
                })
        }

    }

    return (
        <div className="chat-input">
            <form className="user-chat-input">
                <input
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder={`Message #${channelName}`}

                />
                <button type="submit" onClick={sendMessage}>
                    SEND
                </button>
            </form>
        </div>
    )
}